import * as React from 'react';
import cx from 'classnames';
import { User } from '../Icons';

export interface AvatarProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  /**
   * Size of the avatar
   */
  size?: 'sm' | 'md' | 'lg' | 'xl';

  /**
   * Make the avatar covered with border
   */
  bordered?: boolean;

  /**
   * Letter of the avatar to display if image source is not provided.
   */
  // TODO: change the 'label' to 'name'
  label?: string;

  /**
   * State to switch content avatar to show, between image and letter. If `false` will show label. Default is `true`
   */
  image?: boolean;

  /**
   * Source avatar image to display.
   */
  src?: string;

  /**
   * Custom color code of the letter avatar.
   */
  color?: string;

  /**
   * Custom background color code of the letter avatar.
   */
  bgColor?: string;
}

const EmptyImage = () => (
  <div className="bg-[#9b9790] w-full h-full flex items-end">
    <User fill="#585552" width="85%" height="85%" className="mx-auto" />
  </div>
);

export default function Avatar({
  size,
  bordered,
  src,
  alt,
  label,
  color,
  bgColor,
  image = true,
  ...props
}: AvatarProps) {
  return (
    <div className={cx('avatar-root', size, bordered && 'avatar-border')}>
      {image ? (
        src ? (
          <img className="avatar-img" alt={alt ?? ''} src={src} {...props} />
        ) : (
          <EmptyImage />
        )
      ) : label ? (
        <div
          className="w-full h-full flex items-center"
          style={{ backgroundColor: bgColor ?? '#E95344' }}
        >
          <p className="avatar-text" style={{ color: color }}>
            {label}
          </p>
        </div>
      ) : (
        <EmptyImage />
      )}
    </div>
  );
}

Avatar.defaultProps = {
  size: 'md',
  bordered: false,
  alt: '',
  image: true,
};
